import { RECOVERY_CODES_FILE_NAME } from '../config';

export const downloadRecoveryCodes = (codes: string[]) => {
  const url = URL.createObjectURL(
    new Blob([codes.join('\n')], { type: 'text/plain' }),
  );

  // Firefox ignores click() on a detached anchor, and revoking synchronously
  // races the start of the download in several engines.
  const link = document.createElement('a');
  link.href = url;
  link.download = RECOVERY_CODES_FILE_NAME;
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url));
};
